// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2bx9_","dragIcon":"Choice_dragIcon__3xlPD","left":"Choice_left__1VrbW","input":"Choice_input__1AQCL"};